<template>
  <div>
      <NuxtLayout>
          <template #body_page>
              <Banner :title="`Terms of Use`"/>
              <div class='maxw-890 ma-0-auto pl-25 pr-25'>
                  <SectionContent/>
              </div>
          </template>
      </NuxtLayout>
  </div>
</template>

<script>
import { debounceAmplitudeScriptTracking } from '~/mixins/amplitude'
import Banner from '~/components/sections/SectionBannerTitle/BannerTitle'
import SectionContent from '~/components/sections/SectionContentTermOfUse/SectionContent'
import {onMounted/*, computed, ref*/ } from 'vue'
// import Metadata from '~/assets/meta_data.json'

export default {
  name: 'terms-of-use',
  components: {
    Banner,
    SectionContent
  },
  setup() {
    // const route = useRoute()
    // const runtime = useRuntimeConfig()
    // const metaData = ref(Metadata);
    // const canonical = runtime.public.publicDomain + route.path

    onMounted(() => {
      debounceAmplitudeScriptTracking("View Terms of Use")
    })

    // useHead({
    //   title: computed(() => {
    //     const title = metaData.value.terms_of_use.title
    //     return title
    //   }),
    //
    //   meta: computed(() => {
    //     const title = metaData.value.terms_of_use.title
    //     const description = metaData.value.terms_of_use.description
    //     return [
    //       {
    //         name: `title`,
    //         content: title,
    //       },
    //       {
    //         name: `description`,
    //         content: description,
    //       }
    //     ]
    //   }),
    //   link: computed(() => {
    //     return [
    //       { rel: 'canonical', href: `${canonical}`}
    //     ]
    //   }),
    // })
  }
}
</script>

